import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const EventDetailFromHome = ({ data = [] }) => {
  const navigate = useNavigate();

  return (
    <>
      <Row className="my-4 py-2">
        {data.length > 0 &&
          data.map((item, idx) => {
            const imgSrc = `${IMAGE_BASEURL}${item?.cover_image_path}`;

            return (
              <Col
                key={item._id || idx}
                lg={4}
                md={6}
                sm={12}
                className="d-flex align-items-center justify-content-center"
              >
                <Card
                  className="border-0 w-100 h-100 pb-4"
                  onClick={() => {
                    navigate(`/events-gallery/`);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Img
                    className="event-img"
                    src={imgSrc}
                    alt={item?.title || idx}
                  />

                  <Card.Body className="pb-0">
                    <Card.Title className="text-center fw-semibold text-main event-gallary-title">
                      {item?.title}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
      </Row>
    </>
  );
};

export default EventDetailFromHome;
